var _rect, _ellipse, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFundGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eqInu7wEd9h1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 297.631955,
    height: 43.823109,
    rx: 0,
    ry: 0,
    transform: "matrix(1.444107 0 0 1.444107 41.093806 405.766456)",
    fill: "#72788b",
    strokeWidth: 0
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 135,
    ry: 135,
    transform: "matrix(1.343771 0 0 1.343771 256 256)",
    fill: "#b2b2b8",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 68.095416,
    height: 68.095416,
    rx: 0,
    ry: 0,
    transform: "matrix(1.099408 1.099408-1.099408 1.099408 256 181.135389)",
    fill: "#72788b",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFundGray);
export default __webpack_public_path__ + "static/media/icon-fund-gray.49db0970c3c6b40fe0922a7f55ee8eb3.svg";
export { ForwardRef as ReactComponent };